
//Dependencies
import React, { Component } from 'react';
import axios from 'axios';
import Simulador from './Simulador';
import $ from 'jquery';
import { withRouter } from 'react-router-dom';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import { InputLabel, TextField } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContentWrapper from './../../Global/SnackbarContentWrapper';
import Typography from '@material-ui/core/Typography';

import { ValidatorForm, TextValidator  } from 'react-material-ui-form-validator';


// persistencia en redux
import {
    setPlazoFijoConfirmacion,
    setPlazoFijoConfirmacionTerminos,
    setPlazoFijoConfirmacionCBU,
    setPlazoFijoConfirmacionCbuRequested
} from '../../../actions/actions';


import { store } from '../../../store/configure';
import {connect} from 'react-redux';

class Confirmacion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cbuAlias: '',
            openTerminosCondiciones: false,
            scroll: 'paper',
            open: false,
            smallestView: false,
            terminosaceptados:false
        }

        this.simuladorRef = React.createRef();

        this.saveCBU = this.saveCBU.bind(this);
        this.regresar = this.regresar.bind(this);
        this.abrirModal = this.abrirModal.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.aceptarTerminosCondiciones = this.aceptarTerminosCondiciones.bind(this);
        this.verificarCbuAlias = this.verificarCbuAlias.bind(this);
        this.isCbuOk = this.isCbuOk.bind(this);
        this.disabledVerificarCbu = this.disabledVerificarCbu.bind(this)
        this.getTextoSimulacion = this.getTextoSimulacion.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.isCbuOkAndWasRequested = this.isCbuOkAndWasRequested.bind(this);
        
    }

    componentDidMount(){        
        setPlazoFijoConfirmacionCbuRequested( { cbuRequested:false,isCbuOk:false } )
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentWillMount(){
        const persistData = {
            type: 'PLAZO_FIJO_CONFIRMACION',
            data: {
                  titular: "",
                  banco: "",
                  isCbuOk: false,
                  cbuRequested:false,
                  cbuAlias:"",
                  validCbuAlias:""
              }
        }
            
        store.dispatch(
            setPlazoFijoConfirmacion( persistData )
        )
    }

    regresar = () => this.props.history.push('/plazo-fijo/paso-4/');

    saveCBU(event) {
        const name = event.currentTarget.name || event.target.name;
        const esNumero = /^[0-9]+$/;
        
        if (esNumero.test(event.target.value) || event.target.value === ""){
            
            if(event.target.value.length <= 22){
                this.setState({cbuAlias:event.target.value})

                let cbuAliasRedux = event.target.value
    
                //si el nuevo valor es igual a uno previamente calculado lo persito
                //sino lo mato forzando una nueva eventual validacion
                if(cbuAliasRedux !== 
                    this.props.plazoFijoConfirmacion.validCbuAlias){
                        cbuAliasRedux = ""
                }
                setPlazoFijoConfirmacionCBU( { cbuAlias : cbuAliasRedux} )
            }
            
        }
    }

    abrirModal = scroll => () => {
        this.setState({ openTerminosCondiciones: true, scroll });
    }

    cerrarModal() {
        this.setState({ openTerminosCondiciones: false });
    }

    aceptarTerminosCondiciones(event) {
        const persistData = {
            type: 'PLAZO_FIJO_CONFIRMACION_CONFIRMACION',
            acceptTerminosCondiciones:!this.state.terminosaceptados 
        }
        this.setState((state)=>({terminosaceptados:!state.terminosaceptados}))
        store.dispatch(
            setPlazoFijoConfirmacionTerminos( persistData )
        )
    }

    snackbar = () => {
        this.setState({ open: true });
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ open: false });
    };

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        let change = false;
        if(window.innerWidth > 500) change = true;
        this.setState({smallestView:change})
    }

    verificarCbuAlias() {
        $(".load").fadeIn(700);
        axios({
            method: 'get',
            timeout: 60 * 4 * 1000,
            url: localStorage.getItem('url') + '/api/plazoFijo/verificarCBU',
            params: {
                cbu: this.state.cbuAlias
            }
        },{withCredentials: true}).then(response => {
            $(".load").fadeOut(700);
            if (response.status === 200) {
                $(".load").fadeOut(700);

                const persistData = {
                    type: 'PLAZO_FIJO_CONFIRMACION',
                    data: {
                          titular: response.data.nombreTitular,
                          banco: response.data.nombreBancoDestino,
                          isCbuOk: true,
                          cbuRequested:true,
                          cbuAlias:this.state.cbuAlias,
                          validCbuAlias:this.state.cbuAlias
                      },
                }
                    
                store.dispatch(
                    setPlazoFijoConfirmacion( persistData )
                )

            }else{
               
                $(".load").fadeOut(700, () => {
                    setPlazoFijoConfirmacionCbuRequested( { cbuRequested:true,isCbuOk:false } )
                    this.snackbar()    
                });
            }
        }).catch(error => {
            let { status } = error.response

            if(status >= 500){//error de servicio

                $(".load").fadeOut(700, () => {
                    this.props.history.push('/plazo-fijo/PF-fail');
                });    

            }else{//error por parte del usuario
                $(".load").fadeOut(700, () => {
                    setPlazoFijoConfirmacionCbuRequested( { cbuRequested:true,isCbuOk:false } )
                    this.snackbar()    
                });    
            }
        })
    }

    submitInvisible(){

    }

    isCbuOk(){
        let { plazoFijoConfirmacion } =this.props
        //sino se hizo ningun request entonces no se valida el input
        if( !plazoFijoConfirmacion.cbuRequested ){
            return true
        }

        return plazoFijoConfirmacion.isCbuOk
    }

    isCbuOkAndWasRequested(){
        let { plazoFijoConfirmacion } =this.props


        return plazoFijoConfirmacion.cbuRequested && plazoFijoConfirmacion.isCbuOk
    }

    getCbuText(){
        let text = ""
        if( this.isCbuOk() ){
            text = "Debe ser titular de la cuenta"
        }else{
            if(this.state.cbuAlias == ""){
                text = "Campo requerido"
            }else{
                text = "Este CBU es incorrecto"
            }
            
        }
        return text
    }

    disabledVerificarCbu(){
        return this.state.cbuAlias.length !== 22
    }

    getTextoSimulacion(){
        let {plazoFijoLandingPage} = this.props

        let textos = {
            titulo : "Confirmación de tu plazo fijo",
            detalle : "Puede haber una mínima variación respecto a la primera simulación. Por favor revisá y confirmá"
        } 
        
        //sino se simulo un plazo fijo de entrada se cambian los textos
        if(plazoFijoLandingPage === "" || plazoFijoLandingPage.monto === 0){
            textos.titulo = "Simula tu plazo fijo"
            textos.detalle = "Por favor, simulá tu Plazo Fijo antes de confirmar tu operación"
        }

        return textos
    }

    render() {
        let {plazoFijoConfirmacion,classes} = this.props
        let cbuText = this.getCbuText()
        let isCbuOk = this.isCbuOk()
        let verificarDisabled = this.disabledVerificarCbu()
        let textos = this.getTextoSimulacion()
    
        return (
            <div className="confirmacion">
                <div className="confirmacion-container">
                    <Grid container >

                        <Grid item xs={12} md={12}>
                            <Grid container spacing={8} justify="center">
                                <Grid item xs={12} className={classes.titleMediaSmallSize + " " + classes.title + " " + classes.common + " confirmacion-title " + classes.borderTitleConfirmacion}>
                                    {textos.titulo}
                                </Grid>
                            </Grid>
                            <Grid container spacing={8} justify="center">
                                <Grid item xs={12} className={classes.title + " " + classes.common + " confirmacion-content " + classes.titleAclaracion}>
                                    <div>
                                        <p>
                                            {textos.detalle}
                                        </p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} md={9} className="confirmacion-content">
                                    <Simulador innerRef={this.simuladorRef} />
                                </Grid>
                            </Grid>
                            
                            <Grid container spacing={8}>
                                {
                                   this.state.smallestView ?
                                        <Grid item xs={12} className={classes.title + " confirmacion-title " + classes.borderTitleConfirmacion}>
                                            Cuenta de origen y destino de los fondos
                                            </Grid>
                                        :
                                        <div>
                                            <Grid item xs={12} className={classes.title + " confirmacion-title " + classes.borderTitleConfirmacion}>
                                                Cuenta de origen y
                                    </Grid>
                                            <Grid item xs={12} className={classes.title + " confirmacion-title " + classes.borderTitleConfirmacion + " " + classes.confirmacionSmall}>
                                                destino de los fondos
                                    </Grid>
                                        </div>
                                }
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} className={classes.title + " " + classes.common + " confirmacion-content " + classes.titleAclaracion}>
                                    <div>
                                        <p>Ingresá el CBU de una cuenta de tu titularidad desde donde querés que se debite el monto a invertir.</p>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={8}>
                                <Grid item xs={12} className="confirmacion-content">
                                    <Grid container spacing={8}>
                                        <Grid item xs={12} md={9}>
                                            <Grid container spacing={8} >
                                                
                                                <Grid item xs={12} md={6} >
                                                    <TextField
                                                        fullWidth
                                                        value={this.state.cbuAlias}
                                                        onChange={this.saveCBU} 
                                                        label="CBU"
                                                        name="cbuAlias"
                                                        endAdornment={<InputAdornment position="end"><Icon className="icon-alert">info</Icon></InputAdornment>}
                                                        error={!isCbuOk}
                                                        helperText= {cbuText}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={5} className={classes.veriricarCuentas + " " + classes.common}>
                                                    <Button  className={classes.verficarTexto + " " + classes.verficarTextoSmall} disabled={verificarDisabled} onClick={this.verificarCbuAlias} color="primary">VERIFICAR CUENTA</Button>
                                                </Grid>

                                            </Grid>
                                        </Grid> 
                                    </Grid>
                                    {
                                        (plazoFijoConfirmacion.isCbuOk === true) ?
                                            <div>
                                                <p className={classes.titularBanco + " " + classes.common} value={plazoFijoConfirmacion.titular}>Titular: <strong>{plazoFijoConfirmacion.titular}</strong></p>
                                                <p className={classes.titularBanco + " " + classes.common} value={plazoFijoConfirmacion.banco}>Banco: <strong>{plazoFijoConfirmacion.banco}</strong></p>
                                            </div>
                                            : null
                                    }
                                    <div className={classes.acepto + " tyc"}>
                                        <Checkbox name="acceptTerminosCondiciones" 
                                                disabled={this.isCbuOkAndWasRequested() !== true}
                                                // checked={plazoFijoConfirmacion.acceptTerminosCondiciones} 
                                                checked={this.state.terminosaceptados}
                                                // onChange={e=> { console.log("target checked? - ", e.target.checked); }}
                                                onClick ={this.aceptarTerminosCondiciones}  
                                                value={plazoFijoConfirmacion.acceptTerminosCondiciones} 
                                                color='primary' />

                                        Acepto los <p onClick={this.abrirModal('paper')} className={classes.condiciones}>Términos y condiciones</p>

                                    </div>

                                </Grid>
                            </Grid>
                            <Dialog open={this.state.openTerminosCondiciones} onClose={this.cerrarModal} scroll={this.state.scroll} aria-labelledby="scroll-dialog-title" >
                                <DialogTitle id="scroll-dialog-title">Términos y condiciones</DialogTitle>
                                <DialogContent >
                                    <DialogContentText>
                                    CARTERA CONSUMO. SOLO PARA PERSONAS FISICAS MAYORES DE EDAD QUE CONSTITUYAN UN DEPOSITO NUEVO A PLAZO FIJO (PF) SE HAYAN REGISTRADO EN EL PRESENTE SITIO buhobank.com/onboarding/plazo-fijo.  
                                    NO APLICA PARA RENOVACIONES DE PF, CLIENTES CON PRODUCTOS ACTIVOS, NI EMPLEADOS DE BANCO HIPOTECARIO S.A. MONTO MINIMO POR DEPOSITO: $5.000 DURANTE LA FECHA DE VIGENCIA ANTES MENCIONADA. 
                                    LOS DEPÓSITOS EN PESOS Y EN MONEDA EXTRANJERA CUENTAN CON LA GARANTÍA DE HASTA $50.000.000. EN LAS OPERACIONES A NOMBRE DE DOS O MÁS PERSONAS, LA GARANTÍA SE PRORRATEARÁ ENTRE SUS TITULARES. 
                                    EN NINGÚN CASO, EL TOTAL DE LA GARANTÍA POR PERSONA Y POR DEPÓSITO PODRÁ EXCEDER DE $50.000.000, CUALQUIERA SEA EL NÚMERO DE CUENTAS Y/O DEPÓSITOS. 
                                    LEY 24.485, DECRETO Nº 540/95 Y MODIFICATORIOS Y COM. "A" 2337 Y SUS MODIFICATORIAS Y COMPLEMENTARIAS. SE ENCUENTRAN EXCLUIDOS LOS CAPTADOS A TASAS SUPERIORES A LA DE REFERENCIA CONFORME A LOS LÍMITES ESTABLECIDOS POR EL BANCO CENTRAL, LOS ADQUIRIDOS POR ENDOSO Y LOS EFECTUADOS POR PERSONAS VINCULADAS A LA ENTIDAD FINANCIERA. 
                                    PARA DEPÓSITOS A PLAZO FIJO SUPERIORES A $1.000.000, DECLARO BAJO JURAMENTO QUE NO SOY BENEFICIARIO DE LOS CRÉDITOS OTORGADOS CONFORME LO DISPUESTO POR LA COMUNICACIÓN BCRA A 6937 Y COMPLEMENTARIAS (CAPITAL DE TRABAJO, PAGO DE SUELDOS, FINANCIACIÓN PRESTADORES DE SALUD) Y PUNTO 3 DE LA COMUNICACIÓN BCRA A 7006 (CLIENTES NO INFORMADOS EN LA CENTRAL DE DEUDORES). 
                                    EN CASO DE SER BENEFICIARIO DE LOS MENCIONADOS CRÉDITOS, MANIFIESTO CONOCER Y ACEPTAR QUE NO CORRESPONDERÁ APLICAR LA TASA DE INTERÉS MÍNIMA PREVISTA EN EL PUNTO 1.11.1 DE LAS NORMAS SOBRE “DEPÓSITOS E INVERSIONES A PLAZO”. BANCO HIPOTECARIO S.A. CUIT N° 30-50001107-2. RECONQUISTA 151 CABA.
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.cerrarModal} color="primary">Cerrar</Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                    </Grid>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={3000}
                    onClose={this.handleClose}
                >
                    <SnackbarContentWrapper
                        onClose={this.handleClose}
                        variant="error"
                        message="CBU INCORRECTO"
                    />
                </Snackbar>
            </div>
        );
    }
}


const mapStateToProps = (state)=> {
    return ({
        plazoFijoLandingPage: state.plazoFijoLandingPage.data,
        plazoFijoConfirmacion: state.plazoFijoConfirmacion
    });
}

const styles = {
    root: {
        flexGrow: 1,
    },
    common: {
        fontFamily: "Roboto",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: "normal",
    },
    title: {
        opacity: "0.99",
        color: "#333333 !important"
    },
    borderTitleConfirmacion: {
        paddingTop: "0px !important",
        fontSize: "24px !important",
        lineHeight: "0.63",
    },
    titleAclaracion: {
        fontSize: "14px",
        lineHeight: "1.07"
    },
    veriricarCuentas: {
        fontSize: "14px",
        color: "#f37320",
    },
    verficarTexto: {
        textAlign: "left",
        marginTop: "15px",
        color: "#f37320",
        opacity: "0.99"
    },
    titularBanco: {
        fontSize: "14px",
        lineHeight: "1.07",
        color: "#999999"
    },
    acepto: {
        fontSize: "14px",
        color: "#4a4a4a"
    },
    condiciones: {
        color: "#f37321",
        display: "inline",
        cursor:"pointer"
    },
    cbuAlias: {
        fontSize: "20px",
        lineHeight: "0.75",
        color: "#999999"
    },
    cbuInput: {
        fontSize: "20px",
        lineHeight: "0.75",
        color: "#333333"
    },
    '@media  screen and (max-width: 959px)': {
        titleMediaSmallSize: {
            fontSize: "22px !important",
            lineHeight: "0.68"
        },
        verficarTextoSmall: {
            fontSize: "16px",
            lineHeight: "0.94",
            color: "#f37321"
        }
    },
    '@media  screen and (max-width: 665px)': {
        borderTitleConfirmacion: {
            fontSize: "20px !important",
        }
    },
    '@media  screen and (max-width: 500px)': {
        confirmacionSmall: {
            lineHeight: "23px !important",
            border: "none !important",
            marginTop: "0px !important"
        }
    }
};

export default connect(mapStateToProps, null, null, { withRef: true }) 
                ( withRouter(withStyles(styles) (Confirmacion)) );



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/Confirmacion.js